import { render, staticRenderFns } from "./PaymentIframe.vue?vue&type=template&id=1366ba30"
import script from "./PaymentIframe.vue?vue&type=script&lang=js"
export * from "./PaymentIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports